import { render, staticRenderFns } from "./PolicyDetachDopModal.vue?vue&type=template&id=14c7332a&scoped=true"
import script from "./PolicyDetachDopModal.vue?vue&type=script&lang=js"
export * from "./PolicyDetachDopModal.vue?vue&type=script&lang=js"
import style0 from "./PolicyDetachDopModal.vue?vue&type=style&index=0&id=14c7332a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c7332a",
  null
  
)

export default component.exports